export const CONTENT_EVENTS = Object.freeze({
  CONTENT_PAGE_VIEWED: {
    name: 'content_page_viewed',
    category: 'Content',
    description: '内容页或内容列表页查看时触发',
    // 页面曝光类事件显式抬到 full 档（2026-10-27）：公开案例页/博客页是 SEO 来量，
    // 这批用户很可能**永远不进上传链路**，页面曝光就是他们唯一的会话级时区锚点。
    // ⚠️ 本事件自有参数 23 是 page_view 里最重的 ⇒ 声明峰值 23 + 5 + 1 = 29 > 25 安全线
    //    （静态门会把它列进「可能触顶」）。实测当前代码实发 12~17（含全局 2 个），
    //    改 full 后 14~20，仍在 25 内；但若某分支真的把 23 个声明参数全填满就会挤掉全局字段。
    //    ⇒ 待办：先给本事件做参数下沉（阶段 3 的 constants / redundantParams）再谈长期稳定。
    globalsProfile: 'full',
    requiredParams: ['module_name', 'source_position', 'content_type'],
    optionalParams: [
      'event_label', 'element_name', 'element_type', 'method', 'action_status', 'reason_code',
      'content_id', 'related_content_id', 'related_content_type', 'lang', 'blog_slug',
      'blog_category', 'blog_tag_count', 'post_count', 'total_post_count', 'page_number',
      'total_pages', 'posts_per_page', 'is_logged_in', 'navigation_trigger'
    ]
  },
  CONTENT_LIST_OPTION_CHANGED: {
    name: 'content_list_option_changed',
    category: 'Content',
    description: '内容列表筛选、排序或分页变化时触发',
    requiredParams: ['module_name', 'source_position', 'option_name', 'option_value'],
    optionalParams: [
      'event_label', 'element_name', 'element_type', 'method', 'action_status', 'reason_code',
      'previous_value', 'content_id', 'content_type', 'blog_category', 'post_count',
      'page_number', 'total_pages', 'posts_per_page', 'lang', 'is_logged_in'
    ]
  },
  CONTENT_ITEM_CLICKED: {
    name: 'content_item_clicked',
    category: 'Content',
    description: '内容列表项、文章导航、相关推荐等内容对象点击时触发',
    requiredParams: ['module_name', 'source_position', 'element_name', 'element_type'],
    optionalParams: [
      'event_label', 'method', 'action_status', 'reason_code', 'content_id', 'content_type',
      'related_content_id', 'related_content_type', 'blog_slug', 'blog_category', 'item_index',
      'navigation_type', 'destination_type', 'destination_id', 'lang', 'is_logged_in'
    ]
  },
  CONTENT_LOAD_COMPLETED: {
    name: 'content_load_completed',
    category: 'Content',
    description: '内容正文资源加载完成、失败、缺失或被阻断时触发',
    requiredParams: ['module_name', 'source_position', 'content_type', 'action_status'],
    optionalParams: [
      'event_label', 'element_name', 'element_type', 'method', 'reason_code', 'content_id',
      'blog_slug', 'blog_category', 'markdown_source_state', 'has_markdown_content',
      'duration_ms', 'http_status', 'lang', 'is_logged_in'
    ]
  },
  CONTENT_READING_DEPTH_REACHED: {
    name: 'content_reading_depth_reached',
    category: 'Content',
    description: '内容详情页阅读深度达到指定阈值时触发',
    requiredParams: ['module_name', 'source_position', 'content_id', 'content_type', 'reading_depth_percent'],
    optionalParams: [
      'event_label', 'element_name', 'element_type', 'method', 'option_name', 'option_value',
      'blog_slug', 'blog_category', 'lang', 'is_logged_in'
    ]
  },
  BLOG_ARTICLE_CLICKED: {
    name: 'blog_article_clicked',
    category: 'Content',
    description: '博客文章点击时触发（兼容旧事件，新代码应使用 content_item_clicked）',
    requiredParams: [],
    optionalParams: ['slug', 'source', 'is_logged_in']
  },
  CONTENT_CTA_CLICKED: {
    name: 'content_cta_clicked',
    category: 'Content',
    description: '内容页 CTA 点击时触发',
    requiredParams: ['module_name', 'source_position', 'element_name', 'element_type'],
    optionalParams: [
      'event_label', 'method', 'content_id', 'content_type', 'blog_slug', 'blog_category',
      'cta_type', 'destination_type', 'destination_id', 'lang', 'is_logged_in'
    ]
  }
});

// Blog 搜索功能埋点枚举（plan_0.8.4.2.6.1 步骤 6）
// 集中登记搜索相关枚举值，确保代码中引用与埋点字典文档一致，且不被 hook 过滤。
export const BLOG_SEARCH_ANALYTICS = Object.freeze({
  CONTENT_TYPE: 'blog_search',
  SOURCE_POSITION_RESULT: 'blog_search',
  SOURCE_POSITION_POSTS: 'blog_search_posts',
  SOURCE_POSITION_LIST_SEARCH: 'blog_list_search',
  OPTION_NAME: 'blog_search',
  OPTION_VALUE_SUBMITTED: 'submitted',
  OPTION_VALUE_EMPTY_QUERY: 'empty_query',
  NAVIGATION_TYPE_TO_DETAIL: 'search_to_detail',
  REASON_CODE_QUERY_EMPTY: 'blog_search_query_empty'
});
